import {get as _get} from 'lodash';
import {REHYDRATE} from 'redux-persist/lib/constants';

import * as actionTypes from '@actions/actionTypes';
import {mergeRehydrate} from '@reducers/rehydrateUtils';

const initialState = {};

/**
 * Add timestamp to object
 * The Timestamp is used to compare timestamp (prevTimestamp > currentTimestamp)
 * and refetch data after click on "Search" button
 */
const getDataWithTimestamp = (data) => ({
    ...data,
    timestamp: Date.now(),
});

const filterReducer = (state = initialState, action) => {
    switch (action.type) {
        /**
         * Initial timestamp, when mount component with filters
         */
        case actionTypes.SET_INITIAL_FILTER: {
            let {name} = action.data,
                actualStateTimestamp = _get(state, `${[name]}.params.timestamp`, null);

            if (null === actualStateTimestamp) {
                let {data} = action.data,
                    dataWithTimestamp = getDataWithTimestamp(data);

                return {
                    ...state,
                    [name]: {
                        params: {...dataWithTimestamp},
                    },
                };
            }

            return state;
        }

        case actionTypes.SET_FILTER : {
            let {name, data, forceRefresh} = action.data;
            let filterData = {...data};

            for (const key in filterData) {
                if (null === filterData[key]) {
                    delete filterData[key];
                }
            }

            if (true === forceRefresh) {
                filterData = getDataWithTimestamp(filterData);
            }

            return {
                ...state,
                [name]: {
                    params: {...filterData},
                    areFiltersVisible: _get(state, `${[name]}.areFiltersVisible`, true),
                },
            };
        }

        case actionTypes.RESET_FILTER: {
            const resource = {...state};

            delete resource[action.data.params];

            return resource;
        }

        case actionTypes.FILTERS_VISIBILITY: {
            const filtersVisible = _get(state, `${action.data.key}.areFiltersVisible`, true);

            return {
                ...state,
                [action.data.key]: {
                    ...state[action.data.key],
                    areFiltersVisible: !filtersVisible,
                },
            };
        }

        case REHYDRATE: {
            return {
                ...state,
                ...mergeRehydrate(action, 'payload.app.filters', initialState),
            };
        }

        default:
            return state;
    }
};

export default filterReducer;
